// extracted by mini-css-extract-plugin
module.exports = {"root":"info-list_root__v5C36"};